<template>
    <div class="mine-content">
      <div class="mine-header"><span @click="util.goblack()" class="back"><img src="@/assets/images/base/icon_righ_g.png"/></span>Avatar</div>
        <div class="Avatarbox">
          <app-scroll>
            <div class="first">
              <p>Default</p>
              <div class="imgbigbox">
                <div class="imgbox" @click="onAvater(0)">
                  <img src="@/assets/images/avater/0.png" />
                </div>
              </div>
            </div>
            <div class="first">
              <p>Male</p>
              <div class="imgbigbox">
                <div class="imgbox" v-for="i in 30" :key="i" @click="onAvater(i)">
                  <img :src='require("@/assets/images/avater/"+ i +".png")'/>
                </div>
              </div>
            </div>
            <div class="first">
              <p>Female</p>
              <div class="imgbigbox">
                <div class="imgbox" v-for="i in 30" :key="i" @click="onAvater(i+30)">
                  <img :src='require("@/assets/images/avater/"+ (i+30) +".png")'/>
                </div>
              </div>
            </div>
          </app-scroll>
        </div>
        <van-loading v-show="showloding" size="50px" color="#1989fa" vertical/>
    </div>
    </template>
    <script>
    /*global mui*/
    import Vue from "vue";
    import Scroll from "@/coms/scroll";
    import { Loading } from "vant";
    Vue.use(Loading);
    export default {
      components: {
        [Scroll.name]: Scroll
      },
      data() {
        return {
          fieldKey: "ico_picture",
          showloding: false,
          userInfo:this.util.user,
        };
      },
      methods: {
        onAvater(num) {
          let _this = this;
          if (!_this.showloding) {
            var btnArray = ["Cancel", "OK"];
            mui.confirm("Whether to use this avatar?", "Set Avatar", btnArray, function(e) {
              if (e.index == 1) {
                _this.SetupUser(_this.fieldKey, num);
              } else {
                _this.showloding = false;
                mui.confirm();
              }
            });
          } else {
            mui.toast("Being modified, please wait...");
          }
        },
        //修改用户资料
        SetupUser(fieldKey, fieldValue) {
          let params = {fieldKey:fieldKey,fieldValue :fieldValue};
          this.util.setDnValueUser(params);
          this.axios.post(this.api.api_updateUserInfo, this.util.encodeSearchParams(params)).then(res => {
              this.showloding = false;
              if (res.data.code == 0) {
                this.userInfo.ico_picture = fieldValue;
                this.userInfo.ico_picture_img = require('@/assets/images/avater/'+fieldValue+'.png'),
                window.history.back();
              } else {
                mui.toast(res.data.message);
              }
            })
            .catch(() => {
              this.showloding = false;
              mui.toast("Modification failed");
            });
        }
      }
    };
    </script>
    <style lang="scss" scoped>
    .mine-content{
      font-size: 0.34rem;
      background: rgb(235, 235, 235);
      color:rgb(103, 103, 103);
      width: 100%;
      height: 100%;
      .mine-header{
        height: 1.2rem;
        display: grid;
        grid-template-columns: 30% 1fr 30%;
        align-items: center;
        text-align: center;
        color:black;
        font-weight: bold;
        .back{
          cursor: pointer;
          img{
            display: block;
            margin-left: 5%;
            width: 0.5rem;
            transform: rotate(180deg);
          }
        }
      }
      .Avatarbox {
        background: white;
        width: 100%;
        padding-top: 0.2rem;
        position: absolute;
        top: 1.2rem;
        left: 0;
        bottom: 0;
        .scroll-wrap {
          width: 100%;
          height: 100%;
        }
        p {
          width: 100%;
          font-size: 0.34rem;
          height: 0.52rem;
          line-height: 0.52rem;
          color: #666666;
          padding: 0 0.5rem;
          margin: 0;
        }
        .imgbigbox {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          padding: 0.5rem;
          box-sizing: border-box;
          .imgbox {
            width: 20%;
            padding: 0.1rem 0;
            display: flex;
            justify-content: space-around;
            align-items: center;
            img {
              width: 1.2rem;
              height: 1.2rem;
              border-radius: 50%;
            }
          }
        }
      }
    }
    </style>  